import React,{useState,useEffect} from 'react';
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow
        ,Card,TextField,Box, Paper,Tooltip,IconButton, Typography} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    estiloCard:{
        width: '61rem',
        boxShadow:'0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 2%)',
       // color:'#4a4a4a',
        display:'block',
        paddingBottom:'.5rem',
        paddingLeft:'.5rem',
        paddingRight:'.5rem',
        maxHeight:'100%',
        minHeight: "11rem",
        marginRight:'1rem'
    },  
    tablaContainer: {
        width: '60rem',
        maxHeight: "26rem",
        minHeight: "8rem",
        //minWidth:'100%',
      }, 
    tableRow: {
      "&$selected, &$selected:hover": {
        backgroundColor:process.env.REACT_APP_Color_Second
      }
    },
    tableCell: {
      "$selected &": {
        color: "white"
      }
    },
    hover: {},
    selected: {}
  });

  const columnas=[                    
    { id:1, titulo:"Comunas", alinear:'center' },      
    { id:2, titulo:"Distritos", alinear:'center' },         
    { id:3, titulo:"Zona/Barrios", alinear:'center' },          
    { id:4, titulo:"Población", alinear:'center' },                  
    { id:5, titulo:"Avenidas y Calles Principales", alinear:'center' },                  
  ];
 
export default function TablaComuna({listComunaDet }){    
  const classes = useStyles();    
  const [registro, setRegistro] = useState(null)
  const [datos,setDatos] = useState([]);     
  const auxCol=process.env.REACT_APP_Fondo_Color
  
  useEffect(()=>{
    setDatos(listComunaDet) 
    
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[listComunaDet])          

  const onChangeTable =(regis)=>{                       
    setRegistro(regis)
  } 

  const celda = (alinear, estilo, contenido,index) => {
    return (
    <TableCell align={alinear} key={index} className={classes.tableCell} 
        padding={'none'} style={estilo} >
        {contenido}
    </TableCell>)
  }

  const CelTitl=({index,titulo,aline})=> celda(aline?aline:"center", {fontWeight:700}, titulo?titulo:"",index) 

  function TablaCom(auxDatos) {        
    
    return(        
    <TableContainer className={classes.tablaContainer} id="tamTablaReg"  >
      <Table stickyHeader aria-label="sticky table">
        <TableHead >  
           <TableRow>                      
            <TableCell  padding={'none'}  align='center' colSpan={5} style={{backgroundColor:auxCol,color:'white',}}>
              Comunas de la ciudad de Cochabamba
            </TableCell>                          
          </TableRow>  
          <TableRow>          
            {columnas.map((columna,index)=>              
              <CelTitl index={index+5} titulo={columna.titulo} aline={columna.alinear} />                          
            )}                                       
          </TableRow>                        
        </TableHead>  
        <TableBody>         
        {auxDatos.map((elemnto,index) => {  
          const auxVal=registro?.ComNom === elemnto?.ComNom ?true:false                                              
          return (                  
          <TableRow className={classes.tableRow} selected={ auxVal} 
            classes={{ hover: classes.hover, selected: classes.selected }} 
            key={index+1} onClick={ () => onChangeTable(elemnto) }  
          >            
            {celda("left", {width:"3rem"}, elemnto.ComNom,index+1) }
            {celda("center", {width:"3rem",}, elemnto.Distritos,index+2) }                
            {celda("left", {width:"8rem",fontSize:"12px"}, elemnto.Barrios,index+4) }    
            {celda("center", {width:"4.3rem",}, elemnto.Poblacion,index+5) }            
            {celda("left", {width:"8rem",fontSize:"12px",paddingLeft:".4rem"}, elemnto.Avenidas,index+6) }            
          </TableRow>              
          );                        
          })
        }                                                
        </TableBody>
      </Table>
    </TableContainer>        
    ); 
  }
                   
  const llamada=  datos.length !== 0 ?(TablaCom(datos)):(<Box style={{paddingTop:1+'rem'}}>
                                    <Typography variant="h5" component="h5">No contiene datos</Typography>
                                    </Box>) 
  return (
  <Box display={'flex'} flexDirection="row"style={{height: "24.5rem"}}> 
    <Card className={classes.estiloCard} style={{height:"24rem"}}>                                   
      {  llamada }   
    </Card>   
  </Box>                   
  );
}